// extracted by mini-css-extract-plugin
module.exports = {"main":"OBTColorPickerMain_main__17lyZ","disabled":"OBTColorPickerMain_disabled__2H1hL","dialog":"OBTColorPickerMain_dialog__2NFy4"};